var params = { 
  apiKey: 'vgufCKYxbRhtNJ4cIk1rUAzciw2TsADlkM6WbQu0',
  popupIntegration: {
    centeredHorizontal: true,
    centeredVertical: true,
    width: '1024px',
    height: '768px',
  },
  onIssue : (data) => {
    console.log(data);
  }
};

window.onload = function() {  
  const vtoButton = document.getElementById("vto-button");
  const barcode = vtoButton.getAttribute("data-barcode");
  params.frame = barcode;

  window.fitmixInstance = FitMix.createWidget('fitmix-container', params, function() {
    console.log('FitmixWidget creation complete!');
  });
  main(barcode);
}

const fitmix = document.getElementById("fitmix-container");

function hide(){
  fitmix.style.display= 'none';
}

function show(){
  fitmix.style.display= 'block';
}

function openVto(){
  fitmixInstance.startVto('live')
  show()
}

function stopVto(){
  fitmixInstance.stopVto()
}

/**
 * @param {string[]} idTable
 * @returns  {Promise<{uid: string, available: boolean}[]>} 
 **/
async function getAvailability(idTable)  {
    const apiKey = "vgufCKYxbRhtNJ4cIk1rUAzciw2TsADlkM6WbQu0"
    const url = `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${apiKey}&uidList=${idTable.join(",")}`

    const result = await fetch(url)
    if (result.ok) {
        return  result.json() 
    }

    throw new Error("an error occured")
}

async function main(barcode) {
    const idTable = [barcode]
    try {
        const availabilityResult = await getAvailability(idTable);
        const vtoButton = document.getElementById("vto-button");
        availabilityResult.forEach(({available}) => {
          if(!available) {
            // hide the VTO button if the product is not available
            vtoButton.style.display = 'none';
          }
        });
    } catch(err) {
        // Handle fetch error
        console.error(err);
    }
}

(function() {
  const trackVTO = () => {
    const vtoBtn = document.getElementById('vto-button');
    // Only attach if the button exists and hasn't been tagged yet
    if (vtoBtn && !vtoBtn.dataset.gaTrackingSet) {
      vtoBtn.addEventListener('click', function() {
        if (typeof gtag === 'function') {
          gtag('event', 'virtual_try_on_start', {
            'event_category': 'engagement',
            'product_id': vtoBtn.getAttribute('data-barcode') || 'none'
          });
        }
      });
      vtoBtn.dataset.gaTrackingSet = "true"; // Prevents double-tracking
    }
  };

  // Check immediately
  trackVTO();

  // Also watch the page in case the app injects the button late
  const observer = new MutationObserver(trackVTO);
  observer.observe(document.body, { childList: true, subtree: true });
})();